class AlertManager {
  constructor() {
    this.alerts = [];
    this.container = null;
    this.createContainer();
  }

  createContainer() {
    this.container = document.createElement('div');
    this.container.className = 'alert-container';
    this.container.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 99999999;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 12px 16px;
      pointer-events: none;
    `;
    document.body.appendChild(this.container);
  }

  showAlert(message, type = 'info', duration = 3000) {
    const alert = {
      id: Date.now() + Math.random(),
      message,
      type,
      element: null,
      timeout: null
    };

    alert.element = this.createAlertElement(alert);
    this.container.appendChild(alert.element);
    this.alerts.push(alert);

    // Giriş animasyonu
    requestAnimationFrame(() => {
      alert.element.classList.add('alert--show');
    });

    // Progress bar animasyonu ve otomatik kapanma
    if (duration > 0) {
      const progressBar = alert.element.querySelector('.alert__progress-fill');
      if (progressBar) {
        requestAnimationFrame(() => {
          progressBar.style.transition = `width ${duration}ms linear`;
          progressBar.style.width = '0%';
        });
      }

      alert.timeout = setTimeout(() => {
        this.removeAlert(alert.id);
      }, duration);
    }

    return alert.id;
  }

  isMobile() {
    return window.innerWidth <= 768;
  }

  createAlertElement(alert) {
    const mobile = this.isMobile();

    // Web: pastel, sade, kurumsal | Mobil: doygun, dikkat çekici
    const colors = mobile ? {
      success: { bg: '#C8E6C9', border: '#388E3C', icon: '#1B5E20', text: '#1B5E20' },
      error:   { bg: '#FFCDD2', border: '#D32F2F', icon: '#B71C1C', text: '#B71C1C' },
      warning: { bg: '#FFE0B2', border: '#F57C00', icon: '#E65100', text: '#E65100' },
      info:    { bg: '#BBDEFB', border: '#1976D2', icon: '#0D47A1', text: '#0D47A1' }
    } : {
      success: { bg: '#E8F5E9', border: '#4CAF50', icon: '#2E7D32', text: '#2E7D32' },
      error:   { bg: '#FFEBEE', border: '#F44336', icon: '#C62828', text: '#C62828' },
      warning: { bg: '#FFF8E1', border: '#FF9800', icon: '#E65100', text: '#E65100' },
      info:    { bg: '#E3F2FD', border: '#2196F3', icon: '#1565C0', text: '#1565C0' }
    };
    const icons = {
      success: 'uil-check-circle',
      error: 'uil-exclamation-circle',
      warning: 'uil-exclamation-triangle',
      info: 'uil-info-circle'
    };

    const c = colors[alert.type] || colors.info;

    const element = document.createElement('div');
    element.className = `alert-toast alert-toast--${alert.type}`;
    element.style.background = c.bg;

    element.innerHTML = `
      <div class="alert__body">
        <i class="${icons[alert.type] || icons.info} alert__icon" style="color:${c.icon}"></i>
        <span class="alert__message" style="color:${c.text}">${alert.message}</span>
        <button class="alert__close" aria-label="Kapat" style="color:${c.icon}">
          <i class="uil-times-circle"></i>
        </button>
      </div>
      <div class="alert__progress">
        <div class="alert__progress-fill" style="background:${c.border};width:100%"></div>
      </div>
    `;

    // Close butonu
    const closeBtn = element.querySelector('.alert__close');
    closeBtn.addEventListener('click', () => this.removeAlert(alert.id));

    return element;
  }

  removeAlert(id) {
    const alertIndex = this.alerts.findIndex(a => a.id === id);
    if (alertIndex > -1) {
      const alert = this.alerts[alertIndex];

      if (alert.timeout) clearTimeout(alert.timeout);

      alert.element.classList.remove('alert--show');
      alert.element.classList.add('alert--hide');

      setTimeout(() => {
        if (alert.element && alert.element.parentNode) {
          alert.element.parentNode.removeChild(alert.element);
        }
        this.alerts.splice(alertIndex, 1);
      }, 300);
    }
  }

  clearAllAlerts() {
    [...this.alerts].forEach(alert => this.removeAlert(alert.id));
  }

  showSuccess(message, duration = 3000) {
    return this.showAlert(message, 'success', duration);
  }

  showError(message, duration = 3000) {
    return this.showAlert(message, 'error', duration);
  }

  showWarning(message, duration = 3000) {
    return this.showAlert(message, 'warning', duration);
  }

  showInfo(message, duration = 3000) {
    return this.showAlert(message, 'info', duration);
  }
}

// Global instance
const alertManager = new AlertManager();

// Stiller
const style = document.createElement('style');
style.textContent = `
  .alert-toast {
    width: 100%;
    max-width: 420px;
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
    pointer-events: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08);
    transform: translateY(-20px) scale(0.95);
    opacity: 0;
    transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.73, 1), opacity 0.3s ease;
  }

  /* background renkleri inline olarak isMobile() ile belirlenir */

  .alert--show {
    transform: translateY(0) scale(1) !important;
    opacity: 1 !important;
  }

  .alert--hide {
    transform: translateY(-20px) scale(0.95) !important;
    opacity: 0 !important;
  }

  .alert__body {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 16px;
  }

  .alert__icon {
    font-size: 20px;
    flex-shrink: 0;
  }

  .alert__message {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
  }

  .alert__close {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    border-radius: 50%;
    font-size: 18px;
    cursor: pointer;
    transition: transform 0.1s ease, opacity 0.1s ease;
    -webkit-tap-highlight-color: transparent;
    padding: 0;
  }

  .alert__close:active {
    transform: scale(0.8);
    opacity: 0.6;
  }

  .alert__progress {
    height: 3px;
    background: rgba(0, 0, 0, 0.06);
  }

  .alert__progress-fill {
    height: 100%;
    border-radius: 0 3px 3px 0;
  }

  @media (max-width: 768px) {
    .alert-container {
      padding: 8px 12px !important;
    }

    .alert-toast {
      max-width: none;
      border-radius: 10px;
    }

    .alert__body {
      padding: 12px 14px;
      gap: 8px;
    }

    .alert__message {
      font-size: 13px;
    }

    .alert__close {
      width: 32px;
      height: 32px;
      font-size: 18px;
    }
  }
`;
document.head.appendChild(style);

// Export
export const showAlert = (message, type = 'info', duration = 3000) => {
  return alertManager.showAlert(message, type, duration);
};

export const showSuccess = (message, duration = 3000) => {
  return alertManager.showSuccess(message, duration);
};

export const showError = (message, duration = 3000) => {
  return alertManager.showError(message, duration);
};

export const showWarning = (message, duration = 3000) => {
  return alertManager.showWarning(message, duration);
};

export const showInfo = (message, duration = 3000) => {
  return alertManager.showInfo(message, duration);
};

export const removeAlert = (id) => {
  return alertManager.removeAlert(id);
};

export const clearAllAlerts = () => {
  return alertManager.clearAllAlerts();
};

export default {
  showAlert,
  showSuccess,
  showError,
  showWarning,
  showInfo,
  removeAlert,
  clearAllAlerts
};
